// src/data/platformEmail.js - task list section 776. Bob 2026-10-22 14:53-14:58 ET accepted the e-mail limits: every e-mail
// the platform sends is a NOTICE WITH NO CONTENT - no name, no claim number, no claim text, no amount, no attachment - and
// one link, to the platform's sign-in page. What it is about is read on the platform, behind sign-in and the committee
// walls. PURE; shared with functions\ by scripts\sync-shared-modules.js. Every e-mail the platform queues is built here
// (the Trigger Email shape the 'mail' collection carries): the deadline alerts, the ruling 325 print notice and messages.
//
// The other limits are kept where they act: the server alone queues mail (firestore.rules gives no client write on
// 'mail'); recipients are the account's own VERIFIED address or the office holder of record (functions\index.js); one notice
// per side per message thread until it is read (src\data\memberMessages.js); e-mail is OFF until platformSettings/email
// switches each kind on; the no-reply mailbox's auto-answer and the domain's SPF/DKIM records are set outside the code.

const s = (v) => (v == null ? '' : String(v)).trim();

export const KINDS = Object.freeze({
  message: 'You have a new message',
  notice: 'You have a new notice',
  deadline: 'A deadline notice is waiting for you',
});

export function noticeEmail(to, installation, kind) {
  const inst = installation || {};
  const what = KINDS[kind] || KINDS.notice;
  const name = s(inst.platformName) || 'the platform';
  const site = s(inst.siteUrl);
  return {
    to: [s(to)],
    message: {
      subject: what + ' on ' + name,
      text: what + ' on ' + name + '.\n\n'
        + 'Sign in to read it' + (site ? ': ' + site : '') + '\n\n'
        + 'This e-mail carries no details on purpose. This address is not read; reply on the platform.',
    },
  };
}
